<form [formGroup]="form" (ngSubmit)="onSubmit()" class="orgFormModal">
  <div class="modal-header">
    <span class="sm-text-xl sm-font-medium" i18n>{{ title }}</span>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body sm-bg-grey-1">
    <div class="project-container">
      <label i18n for="name">Project Name</label>
      <div class="project-input-container">
        <cc-text-input
          [value]="form.get('project').value"
          [hasError]="form.get('project').touched && form.get('project').invalid"
          [placeholder]="'eg. 12 Taylor St Upgrade'"
          (onValueChanged)="form.get('project').setValue($event)"
          name="name"
          id="name"
          (onBlur)="form.get('project').markAsTouched()"
          [autofocus]="true"
        >
        </cc-text-input>
        <div
          *ngIf="form.get('project').invalid && form.get('project').touched"
          class="sm-text-default-red"
          [innerHTML]="form.get('project').errors.message | safeHtml"
        ></div>
      </div>
    </div>
    <hr class="hr" />
    <div class="sm-flex sm-flex-col sm-gap-y-4">
      <ng-container formArrayName="teams" *ngFor="let team of teamsFormArray.controls; let i = index">
        <div [formGroupName]="i" class="team-container">
          <label i18n [for]="'team-name-' + i">Team Name</label>
          <div class="team-input-container">
            <div class="sm-flex sm-w-full sm-flex-row sm-gap-x-2">
              <cc-text-input
                [value]="team.get('name').value"
                [placeholder]="'eg. Site Team'"
                [hasError]="team.get('name').touched && team.get('name').invalid"
                (onValueChanged)="team.get('name').setValue($event)"
                (onBlur)="team.get('name').markAsTouched()"
                [name]="'team-name-' + team.id"
                [id]="'team-name-' + i"
                [autofocus]="i > 1"
              ></cc-text-input>
              <a
                (click)="removeTeamFromPosition(i)"
                *ngIf="teamsFormArray.controls.length > 1"
                class="sm-self-center sm-text-default-red"
                title="Remove team"
                i18n-title="Remove team"
              >
                <i class="fa fa-times"></i>
              </a>
            </div>
            <div
              *ngIf="team.get('name').invalid && team.get('name').touched"
              class="sm-w-full sm-text-default-red"
              [innerHTML]="team.get('name').errors.message | safeHtml"
            ></div>
          </div>
        </div>
      </ng-container>
      <button
        type="button"
        (click)="addTeam()"
        class="btn btn-primary sm-self-center"
        title="Please input team name"
        i18n-title="Please input team name"
        data-test="add-team-button"
        [disabled]="loading"
      >
        <span i18n>Add team</span>
      </button>
    </div>

    <hr class="hr" />
    <div class="form-group text-center pt-3">
      <button type="submit" class="btn btn-success" data-test="save-project-button" [ccBusyButton]="loading">
        Save
      </button>
    </div>
  </div>
</form>
